import { Button, CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";

interface BtnPropTypes {
  btnTitle: any;
  endIcon?: ReactNode;
  className?: string;
  maxwidth?: string;
  minwidth?: string;
  // handleClick?: () => void;
  handleClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  isPdf?: boolean;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  borderWidth?: number;
  variant?: "contained" | "outlined" | "text";
  sx?: object;
  iswidthInmobile?: boolean;
}

const CustomButton = (props: BtnPropTypes) => {
  const {
    btnTitle,
    iswidthInmobile = false,
    endIcon,
    variant,
    maxwidth,
    minwidth,
    className,
    handleClick,
    loading = false,
    isPdf = false,
    type = "button",
    disabled = false,
    bgColor,
    textColor,
    borderWidth,
    borderColor,
    sx = {},
  } = props;

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (type === "button") {
      e.preventDefault(); // ✅ Prevent unintended form submission
    }
    if (handleClick) {
      handleClick(e);
    }
  };
  return isPdf ? (
    <span
      style={{
        maxWidth: maxwidth,
        minWidth: minwidth,
        height: "52px",
        fontSize: "16px",
        fontWeight: 600,
        borderRadius: "8px",
        background: disabled
          ? "#D3D3D3"
          : "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
        color: disabled ? "#A9A9A9" : "#FFFFFF",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 20px",
        borderWidth: borderWidth,
        cursor: disabled ? "not-allowed" : "pointer",
        ...sx,
      }}
    >
      {btnTitle}
    </span>
  ) : (
    <Button
      variant={variant ? variant : "contained"}
      type={type}
      endIcon={!loading ? endIcon : null}
      onClick={handleButtonClick}
      disabled={disabled || loading}
      className={`${className}`}
      sx={{
        maxWidth: maxwidth,
        minWidth: minwidth,
        height: "52px",
        fontSize: "16px",
        borderRadius: "8px",
        fontWeight: 600,
        color: disabled || loading ? "#A9A9A9" : textColor || "#fff",
        backgroundColor:
          disabled || loading
            ? "#D3D3D3"
            : bgColor ||
              "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)", // ✅ Background color from props (default blue)
        border: borderColor ? `2px solid ${borderColor}` : "none",
        cursor: disabled || loading ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderWidth: borderWidth,
        "@media (max-width: 600px)": {
          minWidth: !iswidthInmobile ? "250px" : "100%",
        },
        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress
          size={24}
          sx={{
            "& svg": {
              stroke: "url(#gradientColor)",
            },
          }}
        />
      ) : (
        btnTitle
      )}

      <svg width="0" height="0">
        <defs>
          <linearGradient id="gradientColor" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#2977CC" />
            <stop offset="100%" stopColor="#1D538F" />
          </linearGradient>
        </defs>
      </svg>
    </Button>
  );
};

export default CustomButton;
